export default {
	logged:null,
	jwt:null,
	acesso_permissao:[],
	acesso_modulo:[],
  	menu:[]
}


// WEBPACK FOOTER //
// ./src/store/usuario/state.js